// IMPORTANT: Import patch BEFORE React to ensure ResizeObserver is patched early
import './patchResizeObserver';

import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "antd/dist/antd.min.css";

// Production builds log nothing at log/info/debug level: those calls printed
// sweep payloads, MPC node topology and invoice responses to the browser console
// (audit D-M1). Warnings and errors still show.
if (process.env.NODE_ENV === "production") {
  const noop = () => {};
  console.log = noop;
  console.info = noop;
  console.debug = noop;
}

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

